module.exports = __webpack_public_path__ + "img/studyLogo.e46f3aa2.png";